import orderStyles from "../../pages/order/order.module.css";

export default function PackageExtraDetails(props) {
  const { instaUserId, dispatchTime, style } = props;

  return (
    <div className={orderStyles.orderInfoContainer} style={style}>
      {dispatchTime && (
        <div className={orderStyles.orderInfo}>
          <h6 className={orderStyles.orderInfoHeader}>Shipping</h6>

          <div className={orderStyles.dividerContainer}>
            <hr className={orderStyles.divider} />
          </div>

          <h6 className={orderStyles.orderInfoDiscription}>Ships within {dispatchTime} days</h6>
        </div>
      )}

      {/*
      <div className={orderStyles.orderInfoSecond}>
        <h6 className={orderStyles.orderInfoHeader}>Order Updates</h6>
        <div className={orderStyles.dividerContainer}>
          <hr className={orderStyles.divider} />
        </div>
        <h6 className={orderStyles.orderInfoDiscription}>
          All updates via Email and Whatsapp
        </h6>
      </div>
      */}

      {instaUserId && (
        <div className={orderStyles.orderInfo}>
          <h6 className={orderStyles.orderInfoHeader}>Support</h6>

          <div className={orderStyles.dividerContainer}>
            <hr className={orderStyles.divider} />
          </div>

          <h6 className={orderStyles.orderInfoDiscription}>
            DM me on ig{" "}
            <a
              className={orderStyles.linkBorder}
              href={"https://www.instagram.com/" + instaUserId}
              rel="noreferrer"
              target="_blank"
            >
              {instaUserId}
            </a>{" "}
            for queries
          </h6>
        </div>
      )}
    </div>
  );
}
